import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";

import { useNavigate } from "react-router-dom";
import { EditTrainingsDet } from "../../../../api/AuthenticationServices";
const EditTrainings = (props) => {
  const location = useLocation();
  const trainingDetails = location.state?.trainingRow;
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const initialValues = {
    trainingName: trainingDetails.name,
    trainingPurpose: trainingDetails.purpose,
  };

  const sendData = async (e, values) => {
    e.preventDefault();
    const data = {
      name: values.trainingName,
      purpose: values.trainingPurpose,
      trainingId: trainingDetails.id,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
      },
    };

    try {
      const res = await EditTrainingsDet(data, config);

      if (res.data.status === "success") {
        // console.log("Inside Successs");
        alert(res.data.message);
        navigate("/admin/viewtrainings");
      } else {
        if (res.data.status === "") {
          alert(res.data.message);
          navigate("/admin/viewtrainings");
        }
      }
    } catch (e) {
      //FIX : Message of error need to be shown to user Only Axios Error Displaying
      alert(e);
      navigate("admin/viewtrainings");
    }
  };
  return (
    <div>
      <Box m="20px">
        <Header
          title="EDIT TRAINING DETAILS"
          subtitle="Update the fields of training"
        />

        <Formik
          // onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            // console.log(values,handleChange)
            <form onSubmit={(e) => sendData(e, values)}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Training Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.trainingName}
                  name="trainingName"
                  error={!!touched.trainingName && !!errors.trainingName}
                  helperText={touched.trainingName && errors.trainingName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Training Purpose"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.trainingPurpose}
                  name="trainingPurpose"
                  error={!!touched.trainingPurpose && !!errors.trainingPurpose}
                  helperText={touched.trainingPurpose && errors.trainingPurpose}
                  sx={{ gridColumn: "span 2" }}
                />
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  disabled={false}
                  color="secondary"
                  variant="contained"
                >
                  Update Training
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  trainingName: yup.string().required("required"),
  trainingPurpose: yup.string().required("required"),
});

export default EditTrainings;
